import { render, staticRenderFns } from "./Dooca.vue?vue&type=template&id=c6b38884"
import script from "./Dooca.vue?vue&type=script&lang=js"
export * from "./Dooca.vue?vue&type=script&lang=js"
import style0 from "./Dooca.vue?vue&type=style&index=0&id=c6b38884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports